import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "./ThemeContext";

import ThemedToastContainer from "./compontents/ThemedToastContainer";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ThemeProvider>
      <App />
      <ThemedToastContainer />
    </ThemeProvider>
  </>
);

reportWebVitals();
